import { useEffect } from "react";

/*
 * this hook creates '--inner-height' global variable.
 * it's needed to fix issue in safari.
 */

const useInnerHeight = () => {
    useEffect(() => {
        const onResize = () => {
            document.body.style.setProperty("--inner-height", `${window.innerHeight}px`);
        };

        window.addEventListener("resize", onResize);
        onResize();

        return () => {
            window.removeEventListener("resize", onResize);
        };
    }, []);
};

export default useInnerHeight;
